export default __webpack_public_path__ + "static/ideal-commercial-boilers-logo-e43cba285e44766d2f43514a8fa1b942.svg";